import {
  QBadge,
  QBox,
  QInheritedFromParentIcon,
  QStack,
  QText,
  useFeatureFlag,
} from '@qualio/ui-components';

import { TemplateParent } from '../../../api/templateApi';

const TypeItemlabel = ({
  templateId,
  templatePrefix,
  templateName,
  parent,
  maxWidth,
}: {
  templateId: number;
  templatePrefix: string;
  templateName: string;
  parent?: TemplateParent | null;
  maxWidth?: string;
}) => {
  const featureFlags = useFeatureFlag();
  const enterpriseAccounts = Boolean(featureFlags['enterprise-accounts']);

  return (
    <QStack direction="row" alignItems="center">
      <QBox>
        <QBadge
          title={templatePrefix}
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
          textTransform="none"
          boxShadow="none"
        >
          {templatePrefix}
        </QBadge>
      </QBox>
      <QText
        title={templateName}
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        overflow="hidden"
        maxWidth={maxWidth}
      >
        {templateName}
      </QText>
      {enterpriseAccounts && parent && (
        <QInheritedFromParentIcon
          data-cy={`inherited-template-icon-${templateId}`}
          parentName={parent.name}
        />
      )}
    </QStack>
  );
};

export default TypeItemlabel;
